/**
 * Created by commyfeng on 2017/3/21.
 */
import RequestErrorType from "./RequestErrorType";
/**
 * 通用的请求错误描述类
 * @param code
 * @param msg
 * @param res
 * @constructor
 */
var RequestError = function RequestError(code, msg, res, errorType) {
  this.code = code;
  this.msg = msg;
  this.res = res;
  this.errorType = errorType || RequestErrorType.LOGIC_ERR;
};
RequestError.prototype.toString = function () {
  var msg = this.msg;
  if (!msg) {
    switch (this.errorType) {
      case RequestErrorType.NETWORK_ERR:
        msg = '网络开小差了！请重试';
        break;
      case RequestErrorType.SYSTEM_ERR:
        msg = '系统貌似开小差了！请重试';
        break;
      case RequestErrorType.LOGIC_ERR:
        msg = '出现未知的逻辑错误！请重试';
        break;
    }
  }
  return this.msg + (this.code ? '(' + this.code + ')' : '');
};
RequestError.prototype.RequestErrorType = RequestError.RequestErrorType = RequestErrorType;
export default RequestError;